import { gql } from '@apollo/client';

export const INTERVIEW_LOGS_QUERY = gql`
  query GetInterviewLogs($limit: Int, $offset: Int, $filters: [ColumnFilterInput], $sorting: [ColumnSortInput]) {
    interviewLogs(limit: $limit, offset: $offset, filters: $filters, sorting: $sorting) {
      items {
        _id
        tag
        level
        payload
        ts
        sectionId
        callId
      }
      totalCount
    }
  }
`;

export default INTERVIEW_LOGS_QUERY;
